const isReportGadget = (
  card: CanvasCard.Card,
): card is CanvasCard.ReportGadgetCard => card.content.type === 'Report Gadget';
export default isReportGadget;
